import script from "./form-phong-ban.vue?vue&type=script&setup=true&lang=js"
export * from "./form-phong-ban.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__